export default __webpack_public_path__ + "static/media/decentralized-icon.0b34caf7.svg";